import { render } from "./BarComponent.vue?vue&type=template&id=4546ffb4"
import script from "./BarComponent.vue?vue&type=script&lang=js"
export * from "./BarComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Gitlab-Runner\\builds\\bssYrz32\\0\\as\\WebServerVisualization\\webclient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__